var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-page-container',{attrs:{"showNav":true}},[_c('div',{staticClass:"welcome"},[_vm._v("Well that led us to a 404 oopsie. 🦄")])])
}
var staticRenderFns = []

export { render, staticRenderFns }